
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.761 12.057A5.768 5.768 0 006 17.818a.418.418 0 00.418.418h10.686a.418.418 0 00.418-.418 5.768 5.768 0 00-5.761-5.761zm0 .836a4.929 4.929 0 014.9 4.507H6.853a4.93 4.93 0 014.908-4.507zM11.761 11.655a3.3 3.3 0 10-3.3-3.3 3.307 3.307 0 003.3 3.3zm0-5.77a2.467 2.467 0 11-2.467 2.467 2.469 2.469 0 012.467-2.467z","fill":"currentColor","stroke":"currentColor","stroke-width":".2"}})])
          )
        }
      }
    